<template>
  <div
    v-if="business"
    class="business-detail-layout"
  >
    <h1>
      {{ business.label }}
    </h1>
    <div class="row">
      <business-basic-info
        class="block"
        :business="business"
      />
      <business-detail-map
        class="block"
        :business="business"
      />
    </div>
    <div
      v-if="business.intro_title && business.intro_content"
      class="row"
    >
      <business-intro

        :description="business.description"
        :title="business.intro_title"
        :content="business.intro_content"
      />
    </div>
    <nearby-businesses-block :city="business.city" />
  </div>
</template>
<script>

export default {
  name: 'BusinessDetailsLayout',
  components: {
    BusinessBasicInfo: () => import(/* webpackChunkName: "businessdetail"  */ `./BusinessBasicInfo`),
    BusinessDetailMap: () => import(/* webpackChunkName: "businessdetail"  */ `./BusinessDetailMap`),
    BusinessIntro: () => import(/* webpackChunkName: "businessdetail"  */ `./BusinessIntro`),
    NearbyBusinessesBlock: () => import(/* webpackChunkName: "businessdetal"  */ `./NearbyBusinesses/NearbyBusinessesBlock`),
    
  },
  beforeCreate() {
    this.$store.dispatch('businessSearch/GET_BUSINESS_DETAIL', window.renaultRent.business_id)
  },
  computed: {
    business() {
      return this.$store.state.businessSearch.businessDetail
    },
  },
}
</script>
<style lang="scss" scoped>

.business-detail-layout {
  margin: auto;
  padding: 0 10px 30px;
  width: 100%;

  @include teq-breakpoint($medium) {
    max-width: calc(100% - 186px);
    padding: 0 0 30px;
  }
}

.row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 0 20px;
  width: 100%;

  @include teq-breakpoint($medium) {
    align-items: stretch;
    flex-direction: row;
  }
}

.block {
  margin: 0 0 20px;

  @include teq-breakpoint($medium) {
    margin: 0;
    width: calc(50% - 10px);
  }
}
</style>
